// Ready-made diagram templates for the TemplatePicker.
//
// Each template's `els` is an element list in the connector-aware insert-bus format the
// importer uses: shapes carry dx/dy (offsets from the viewport center) + w/h/text/fill,
// and connectors link shapes by their template-local `id` (remapped on insert). Held in a
// plain .ts module because cl.jac chokes on large nested data literals - the picker UI is
// the .cl.jac; this is just the data it renders.

export type TemplateEl = {
  id?: string;
  kind: string;
  dx?: number; dy?: number; w?: number; h?: number;
  text?: string; fill?: string;
  from?: string; to?: string; label?: string; endArrow?: boolean;
};

export type Template = { name: string; desc: string; icon: string; els: TemplateEl[] };

export const TEMPLATES: Template[] = [
  {
    name: "Flowchart", desc: "Start, process, decision, done", icon: "flow",
    els: [
      { id: "a", kind: "rectangle", dx: -60, dy: -140, w: 120, h: 48, text: "Start", fill: "#e0e7ff" },
      { id: "b", kind: "rectangle", dx: -60, dy: -56, w: 120, h: 48, text: "Process", fill: "#eef2ff" },
      { id: "c", kind: "diamond", dx: -72, dy: 34, w: 144, h: 84, text: "Decision?", fill: "#fef9c3" },
      { id: "d", kind: "rectangle", dx: -60, dy: 150, w: 120, h: 48, text: "Done", fill: "#dcfce7" },
      { kind: "connector", from: "a", to: "b" },
      { kind: "connector", from: "b", to: "c" },
      { kind: "connector", from: "c", to: "d", label: "yes" },
    ],
  },
  {
    name: "Org chart", desc: "A lead with two teams", icon: "org",
    els: [
      { id: "ceo", kind: "rectangle", dx: -60, dy: -110, w: 120, h: 48, text: "Lead", fill: "#e0e7ff" },
      { id: "l", kind: "rectangle", dx: -170, dy: 20, w: 120, h: 48, text: "Team A", fill: "#eef2ff" },
      { id: "r", kind: "rectangle", dx: 50, dy: 20, w: 120, h: 48, text: "Team B", fill: "#eef2ff" },
      { kind: "connector", from: "ceo", to: "l" },
      { kind: "connector", from: "ceo", to: "r" },
    ],
  },
  {
    name: "Mind map", desc: "A central topic with four ideas", icon: "mind",
    els: [
      { id: "c", kind: "ellipse", dx: -70, dy: -30, w: 140, h: 60, text: "Topic", fill: "#e0e7ff" },
      { id: "n", kind: "ellipse", dx: -55, dy: -170, w: 110, h: 48, text: "Idea 1", fill: "#eef2ff" },
      { id: "s", kind: "ellipse", dx: -55, dy: 130, w: 110, h: 48, text: "Idea 2", fill: "#eef2ff" },
      { id: "w", kind: "ellipse", dx: -240, dy: -14, w: 110, h: 48, text: "Idea 3", fill: "#eef2ff" },
      { id: "e", kind: "ellipse", dx: 130, dy: -14, w: 110, h: 48, text: "Idea 4", fill: "#eef2ff" },
      { kind: "connector", from: "c", to: "n", endArrow: false },
      { kind: "connector", from: "c", to: "s", endArrow: false },
      { kind: "connector", from: "c", to: "w", endArrow: false },
      { kind: "connector", from: "c", to: "e", endArrow: false },
    ],
  },
  {
    name: "Timeline", desc: "Four phases left to right", icon: "time",
    els: [
      { id: "t1", kind: "rectangle", dx: -300, dy: -24, w: 130, h: 48, text: "Phase 1", fill: "#eef2ff" },
      { id: "t2", kind: "rectangle", dx: -130, dy: -24, w: 130, h: 48, text: "Phase 2", fill: "#e0e7ff" },
      { id: "t3", kind: "rectangle", dx: 40, dy: -24, w: 130, h: 48, text: "Phase 3", fill: "#eef2ff" },
      { id: "t4", kind: "rectangle", dx: 210, dy: -24, w: 130, h: 48, text: "Launch", fill: "#dcfce7" },
      { kind: "connector", from: "t1", to: "t2" },
      { kind: "connector", from: "t2", to: "t3" },
      { kind: "connector", from: "t3", to: "t4" },
    ],
  },
];
